import { Provider } from "@angular/core";
import * as services from "./services";

export function provideGeneralLedger(): Array<Provider>
{
    return [
        services.SegmentService,
        services.GlModuleControlService,
        services.JournalTemplateService,
        services.JournalEntryService,
        services.GLDepositService,
        services.FundLookupService,
        services.FiscalService,
        services.BudgetFundService,
        services.BudgetCodeFiscalService,
        services.BudgetAdjustmentService,
        services.GLBatchReceiptPayerLookupService,
        services.GLBatchReceiptService,
        services.AccountLookupService,
        services.AccountDetailDrilldownService,
        services.GLAccountService,
        services.BudgetService,
    ];
}
